export function FullPageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="w-14 h-14 border-4 border-primary-30 border-t-primary rounded-full animate-spin" />
        <div className="text-[13px] font-semibold uppercase tracking-wider text-foreground-muted">
          Loading
        </div>
      </div>
    </div>
  );
}
